export default "__VITE_ASSET__f42168af__"